import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { SnackbarService } from './snack-bar.service';
import { Subscription } from 'rxjs';
import { trigger, transition, animate, style } from '@angular/animations';


@Component({
    selector: 'app-snackbar',
    template: require('./snack-bar.component.html'),
    styles: [require('./snack-bar.component.scss')],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({
                    transform: 'translate(-50%, 100%)',
                    position: 'fixed',
                    left: '50%'
                }),
                animate('400ms ease-in', style({ transform: 'translate(-50%, 0)' }))
            ]),
            transition(':leave', [
                animate('400ms ease-in', style({ transform: 'translate(-50%, 100%)' }))
            ])
        ])
    ]
})
export class SnackBarComponent implements OnInit, OnDestroy {
    public message = '';
    public actions: { label: string; handler: () => void }[] = [];
    public showSnackbar = false;
    private subscription: Subscription = new Subscription();

    constructor(private snackbarService: SnackbarService) { }

    public ngOnInit(): void {
        this.subscription = this.snackbarService.snackbarState$.subscribe(({ message, actions }) => {
            this.message = message;
            this.actions = actions || [];
            this.showSnackbar = true;
        });
        this.subscription = this.snackbarService.snackbarState$.subscribe({
            next: ({ message, actions }) => {
                this.message = message;
                this.actions = actions || [];
                this.showSnackbar = true;
            },
            error: (error) => {
                console.error('Error in snackbar subscription:', error);
                this.showSnackbar = false;
            }
        });
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public onActionClick(action: { label: string; handler: () => void }) {
        action.handler();
        this.showSnackbar = false;
    }
}